import { makeTable } from "../utils/tables";

export const traits = makeTable("traits", [
  "Polite",
  "Optimist",
  "Cynical",
  "Eccentric",
  "Hypochondriac",
  "Honest",
  "Proud",
  "Relentless",
  "Perfectionist",
  "Dishonest",
  "Remorseful",
  "Nearsighted",
  "Creepy",
  "Lazy",
  "Inventive",
  "Rough",
  "Hard-boiled",
  "Savage",
  "Passionate",
  "Too old for this shit",
]);
